import { Builder } from '@builder.io/react';

import UnstyledApplicantText from './unstyled-applicant-text';

Builder.registerComponent(UnstyledApplicantText, {
  name: 'UnstyledApplicantText',
  friendlyName: 'Unstyled Applicant Text',
  inputs: [
    {
      name: 'content',
      type: 'string',
      friendlyName: 'Content',
      helperText:
        'Use the placeholder {first_name} to display the first name of the applicant.',
    },
  ],
});
